import {
  authenticatedFastApiAxiosInstance,
  authenticatedFastApiAxiosInstanceAllowEmptyString,
} from "@/lib/data/http";
import {
  baseFastApiMedicalTreatmentRoute,
  baseFastApiMatterRoute,
} from "@/lib/data/requests/matters/matter";
import { serializeMedicalTreatmentPayload } from "@/lib/data/requests/matters/medical-treatment-payloads";
import {
  type APIResponse,
  type MedicalTreatment,
  type SourceOwnedConnectionCreate,
} from "@/lib/types";

export const createMedicalTreatmentV3 = (
  data: Pick<MedicalTreatment, "matterId" | "type"> &
    Partial<Omit<MedicalTreatment, "connections">> & {
      connections?: SourceOwnedConnectionCreate[];
    },
) => {
  const { connections = [], ...treatmentData } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<APIResponse<MedicalTreatment>>("matters/v4/medical-treatments", {
      ...serializeMedicalTreatmentPayload(treatmentData),
      connections,
    })
    .then((res) => res.data);
};

export const updateMedicalTreatmentV1 = (
  data: Pick<MedicalTreatment, "id" | "dateModified"> &
    Partial<MedicalTreatment>,
) => {
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<
      APIResponse<MedicalTreatment>
    >(baseFastApiMedicalTreatmentRoute, serializeMedicalTreatmentPayload(data))
    .then((res) => res.data);
};

export const deleteMedicalTreatmentV1 = (
  data: Pick<MedicalTreatment, "id" | "matterId">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MedicalTreatment>
    >(`${baseFastApiMatterRoute}/medical-treatments/${id}`)
    .then((res) => res.data);
};
